import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { TfService } from './tf-service.service';
import { Observable, map, catchError, of, firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SignGuardGuard implements CanActivate {
  constructor(private router: Router, private tfService: TfService) { }
  
  canActivate(
    route: ActivatedRouteSnapshot, 
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {
    console.log("SignGuardGuard checking access to:", state.url);
    
    return this.tfService.checkAuthStatus().pipe(
      map(authInfo => {
        const isLoggedIn = authInfo?.isAuthenticated;
        console.log("User authentication status:", isLoggedIn);
        
        if (isLoggedIn) {
          console.log("User is logged in - preventing access to sign-in routes");
          
          // Determine where to redirect based on user group
          if (authInfo.userGroups?.includes('admin')) {
            this.router.navigateByUrl('/admin/cf-dashboard');
          } else {
            this.router.navigateByUrl(this.tfService.getDefaultCustomerDashboardUrlForGroups(authInfo.userGroups));
          }
          
          return false; // Prevent access to login/signup routes
        } 
        
        console.log("User is not logged in - allowing access to sign-in routes");
        return true; // Allow access to login/signup routes
      }),
      catchError(error => {
        console.error("Error checking auth status:", error);
        return of(true); // On error, allow access to be safe
      })
    );
  }
}